import {
	WeaLocaleProvider
} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

export const i18n = {
	label: {
		organization: () => getLabel(25332, '组织结构'),
		collect: () => getLabel(28111, '收藏'),
		helper: () => getLabel(275, '帮助'),
		search: () => getLabel(82529, '搜索'),
		reset: () => getLabel(27088, '重置'),
		ok: () => getLabel(33703, '确定'),
		cancel: () => getLabel(32694, '取消'),
		create: () => getLabel(365, '新建'),
		remove: () => getLabel(20230, '移除'),
		delete: () => getLabel(131966, '删除'),
		modify: () => getLabel(93, '编辑'),
		transfer: () => getLabel(80, '转移'),
		multiRemove: () => getLabel(383696, '批量移除'),
		multiDelete: () => getLabel(32136, '批量删除'),
		save: () => getLabel(30986, '保存'),
		saveAndSetting: () => getLabel(32159, '保存并进入详细设置'),
		add: () => getLabel(131201, '添加'),
		copy: () => getLabel(77, '复制'),
		log: () => getLabel(83, '日志'),
		replace: () => getLabel(84563, '替换'),
		columnVisibleSetting: () => getLabel(32535, '显示列定制'),
		multiModify: () => getLabel(383518, '批量编辑'),
		import: () => getLabel(18596, '导入'),
		export: () => getLabel(28343, '导出Excel'),
		'389091': () => getLabel('389091', "选择班次"),
		'18609': () => getLabel(18609, '共'),
		'30690': () => getLabel(30690, '条数据'),
		year: () => getLabel('26577', "年"),
		month: () => getLabel(6076, '月'),
		day: () => getLabel(1925, '天'),
		hour: () => getLabel('391', "小时"),
	},
	confirm: {
		defaultTitle: () => getLabel(131329, '信息确认'),
		removeSelected: () => getLabel(385639, '确定要移除选择的记录吗？'),
		deleteSelected: () => getLabel(385625, '确定要删除选择的记录吗？'),
		selectedEmpty: () => getLabel(84093, '请至少选择一条记录!'),
		cancelSelected: () => getLabel(384051, '确定要封存选中的记录吗？'),
		doISCancelSelected: () => getLabel(384050, '确定要解封选中的记录吗？'),
		remove: () => getLabel(83449, '确定要移除吗？'),
		delete: () => getLabel(83877, '确定要删除吗？'),
		cancel: () => getLabel(384052, '确定要封存吗？'),
		doISCancel: () => getLabel(384053, '确定要解封吗？'),
		forbidden: () => getLabel(385359, '确定要禁用吗?'),
		active: () => getLabel(385033, '确认要启用吗?'),
	},
	message: {
		authFailed: () => getLabel(2012, '对不起，您暂时没有权限！'),
		actionError: () => getLabel(132200, '操作失败！'),
		opSuccess: () => getLabel(30700, '操作成功'),
		saveSuccess: () => getLabel(83551, '保存成功！'),
		saveFailed: () => getLabel(84544, '保存失败！'),
		removeSuccess: () => getLabel(385950, '移除成功！'),
		deleteSuccess: () => getLabel(83472, '删除成功！'),
		uploadSuccess: () => getLabel('25388', "上传成功")
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrmAttendance/public/i18n.js